import { gql } from "@apollo/client";
import { INTERVIEW_QUESTION_FIELDS } from "graphql/fragments";

const ADD_INTERVIEW_QUESTION = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation AddInterviewQuestion($input: AddInterviewQuestionInput!) {
    addInterviewQuestion(input: $input) {
      interviewQuestion {
        ...InterviewQuestionFields
      }
    }
  }
`;

const UPDATE_INTERVIEW_QUESTION = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation UpdateInterviewQuestion($input: UpdateInterviewQuestionInput!) {
    updateInterviewQuestion(input: $input) {
      interviewQuestion {
        ...InterviewQuestionFields
      }
    }
  }
`;

const REMOVE_INTERVIEW_QUESTION = gql`
  mutation RemoveInterviewQuestion($input: RemoveInterviewQuestionInput!) {
    removeInterviewQuestion(input: $input) {
      clientMutationId
      id
    }
  }
`;

const ADD_MISSION_ROLE_INTERVIEW_FROM_TEMPLATE = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation AddMissionRoleInterviewFromTemplate($input: AddMissionRoleInterviewFromTemplateInput!) {
    addMissionRoleInterviewFromTemplate(input: $input) {
      interview {
        id
        uuid
        type
        name
        description
        timeLimit
        videoUrl
        thumbnailUrl
        questions {
          ...InterviewQuestionFields
        }
      }
    }
  }
`;

const ADD_ROLE_VIDEO_INTERVIEW_QUESTIONS_AGENT_TASK = gql`
  mutation AddRoleVideoInterviewQuestionsAgentTask($input: AddRoleVideoInterviewQuestionsAgentTaskInput!) {
    addRoleVideoInterviewQuestionsAgentTask(input: $input) {
      jobId
    }
  }
`;

const MOVE_INTERVIEW_QUESTION = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation MoveInterviewQuestion($input: MoveInterviewQuestionInput!) {
    moveInterviewQuestion(input: $input) {
      interviewQuestion {
        ...InterviewQuestionFields
      }
    }
  }
`;

export {
  ADD_INTERVIEW_QUESTION,
  UPDATE_INTERVIEW_QUESTION,
  ADD_MISSION_ROLE_INTERVIEW_FROM_TEMPLATE,
  ADD_ROLE_VIDEO_INTERVIEW_QUESTIONS_AGENT_TASK,
  REMOVE_INTERVIEW_QUESTION,
  MOVE_INTERVIEW_QUESTION,
};
